import React from 'react';
import Register from '../features/auth/components/Register';

const RegisterPage = () => {
  return <Register />;
};

export default RegisterPage;
